export default __webpack_public_path__ + "static/media/eye.ed27b7bf.gif";